import React from 'react'
import {
  Body,
  Grid,
  Heading,
  Img,
  PageSection as Section,
  TextVerticalSpacer,
  VerticalSpacer,
} from '@superhi/design'

const GRID_1_CELL_SPAN_1a: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 5,
  xlarge: 4,
}

const GRID_1_CELL_SPAN_2a: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 7,
  xlarge: [6, 12],
}

const GRID_1_CELL_SPAN_1b: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: [8, 12],
  xlarge: [9, 12],
}

const GRID_1_CELL_SPAN_2b: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 7,
  xlarge: 7,
}

const GRID_1_CELL_2_ORDER_TRUE = {
  small: -1,
  medium: -1,
  large: -1,
  xlarge: -1,
}

const GRID_1_CELL_2_ORDER_FALSE = {
  small: -1,
  medium: 1,
  large: 1,
  xlarge: 1,
}

type Props = {
  items: {
    title: string
    subtitle: React.ReactNode
    image: React.ComponentProps<typeof Img>
  }[]
}

const Highlights: React.FC<React.PropsWithChildren<Props>> = ({ items }) => (
  <Section>
    <VerticalSpacer amount={{ small: 40, medium: 56, large: 64 }}>
      {items.map((item, i) => (
        <Grid key={item.title} alignItems="center">
          <Grid.Cell span={i % 2 ? GRID_1_CELL_SPAN_1b : GRID_1_CELL_SPAN_1a}>
            <TextVerticalSpacer level="2">
              <Heading color="BLUE_50" level="2">
                {item.title}
              </Heading>
              <Body level="2">{item.subtitle}</Body>
            </TextVerticalSpacer>
          </Grid.Cell>

          <Grid.Cell
            span={i % 2 ? GRID_1_CELL_SPAN_2b : GRID_1_CELL_SPAN_2a}
            order={i % 2 ? GRID_1_CELL_2_ORDER_TRUE : GRID_1_CELL_2_ORDER_FALSE}
          >
            <Img
              {...item.image}
              backgroundColor="transparent"
              width={1333}
              height={680}
              lazy={i > 0}
            />
          </Grid.Cell>
        </Grid>
      ))}
    </VerticalSpacer>
  </Section>
)

export default Highlights
